// NOTE: Currently suportted formats for DateInput
export const dateFormat = 'yyyy-MM-dd';
export const timeFormat = 'hh:mm aa';
export const dateTimeFormat = `${dateFormat}, ${timeFormat}`;
